<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" lg="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <keystore-form-global :mode="mode" :id="id"  :readonly="!isEditable"></keystore-form-global>
      </b-container>
    </template>
  </page-outline>
</template>
<script>

import backButton from "@/components/common/backButton.vue"
import PageOutline from '@/components/common/PageOutline.vue'
import KeystoreFormGlobal from "@/pages/security/KeystoreFormGlobal.vue";

export default {
  name: 'KeystoreForm',
  components: {
    'back-button': backButton,
    'keystore-form-global':KeystoreFormGlobal,
    'page-outline': PageOutline,

  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    }
  },
  data: () => {
    return {
      formType: 'add',
      pageTitle: '',
      returnUrl: '/security/1'
    }
  },
  created () {
    this.formType = this.mode
    this.pageTitle = this.$i18n.t('common.security.' + this.mode + '_keystore')
  },
  methods: {
  }
}

</script>
